import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferMatchingAnalysis {
  constructor($scope, $timeout, OfferService, UserService, OfferRequestService) {
    $scope.quick_search = function() {
      window.filter_table('table#reels', $scope.query);
      window.filter_table('table#sheets', $scope.query);
    };

    $scope.get_matched_stocklist = function() {
      $scope.items = [];
      $scope.loading = true;
      OfferService.get_matched_items(window.offer_id, window.user_id, $scope.filter, true).then(function(data) {
        $scope.items = data.items;
        $scope.has_reels = _.select(data.items, function(i) {
          return i.is_reels === true;
        }).length > 0;
        $scope.has_sheets = _.select(data.items, function(i) {
          return i.is_reels === false;
        }).length > 0;
        $scope.loading = false;
      });
    };
    
    $scope.get_filter = function() {
      return {
        min_quality_accuracy: 1,
        min_specs_accuracy: 1,
        specs_method_operator: 2,
        specs_method_percentage: 5,
        specs_method_standard: true,
        specs_method_relative: false,
        specs_method_special: false,
        specs_method_advanced: false,
        specs_matching_accurate: true,
        specs_matching_flexible: true,
        specs_matching_basic_only: false,
        special_matching_method: 0, // 0 = quick, 1 = analytical
        special_matching_cuts: 1,
        special_matching_waste: 2,
        special_matching_range: 2,
        buyer_country_id: window.delivery_countries.length > 0 ? window.delivery_countries[0].id : null
      };
    };

    $scope.reset_filter = function() {
      $scope.filter = $scope.get_filter();
    };

    $scope.check_items = function(is_reels) {
      angular.forEach($scope.items, function(item) {
        if (!$scope.show_only_matched || ($scope.show_only_matched && item.is_matched)) {
          if (is_reels && item.is_reels)
            item.checked = $scope.reels_checked;
          else if (!is_reels && !item.is_reels)
            item.checked = $scope.sheets_checked;
        }
      });
    };

    $scope.uncheck_items = function() {
      angular.forEach($scope.items, function(item) {
        if ($scope.show_only_matched && item.checked && !item.is_matched)
          item.checked = false;
      });
    };

    $scope.get_analysis_url = function() {
      return '/admin/marketplace/offers/edit_user_pricing/' + window.offer_id + '?user_id=' + $scope.switch_buyer_id;
    };

    $scope.set_user_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.switch_buyer_id = ui.item.id;
          $scope.$apply();
        }
      });
    };

    $scope.create_stocklist_xls = function() {
      var items = [];
      angular.forEach($scope.items, function(item) {
        if (item.checked)
          items.push(item);
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.selected_items = [];
        angular.forEach(items, function(item) {
          $scope.selected_items.push({
            id: item.id,
            is_matched: item.is_matched
          });
        });
      }
    };
    
    $scope.create_campaign_stocklist_xls = function() {
      return OfferService.create_campaign_xls($scope.offer_id, $scope.user_id, $scope.user_company_title, $scope.user_country_id, $scope.filter);
    };

    $scope.create_personalized_offer = function() {
      var items = [];
      angular.forEach($scope.items, function(item) {
        if (item.checked)
          items.push(item.id);
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.creating_offer = true;
        OfferService.create_personalized_offer(window.offer_id, items, window.user_id).then(function(data) {
          if (data.success)
            $scope.creating_offer = false;
        });
      }
    };

    $scope.mass_edit_prices = function() {
      var items = _.pluck(_.where($scope.items, {
        checked: true
      }), 'id');
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.ospp_items = items;
        $.fancybox($('div#mass_edit_prices'), {
          padding: '5',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          topRatio: 0.15,
          scrolling: 'no'
        });
      }
    };

    $scope.mass_edit_prices_with_charge = function() {
      var items = _.pluck(_.where($scope.items, {
        checked: true
      }), 'id');
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.ospp_items = items;
        $.fancybox($('div#mass_edit_prices_with_charge'), {
          padding: '5',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          topRatio: 0.15,
          scrolling: 'no'
        });
      }
    };

    $scope.activate_prices = function() {
      $scope.$broadcast('open_activate_price_dialog', {
        offer_id: window.offer_id,
        supplier_id: window.supplier_id,
        buyer_id: window.user_id,
        country_id: $scope.filter.buyer_country_id
      });
    };

    $scope.copy_to_fca = function(source) {
      var items = _.where($scope.items, {
        checked: true
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        var updated_items = [];
        _.each(items, function(item) {
          var exw = null;
          if (source == 'last_avg_price') {
            if (item.last_avg_price)
              exw = item.last_avg_price.price;
          } else {
            exw = item[source];
          }
          if (exw && source == 'order_fca') {
            if (item.order_charge)
              exw = exw - item.order_charge;
            else
              exw = exw - $scope.order_charge;
          } else if (exw && source == 'ospp_fca') {
            if (item.ospp_charge)
              exw = exw - item.ospp_charge;
            else
              exw = exw - $scope.order_charge;
          }
          if (exw)
            updated_items.push({
              id: item.id,
              exw: exw
            });
        });
        if (updated_items.length > 0) {
          $scope.updating = true;
          OfferService.update_stock_items_user_fca(updated_items, window.user_id, window.offer_id, $scope.country_id).success(function(data) {
            if (data.success) {
              $scope.get_matched_stocklist();
              $scope.updating = false;
            }
          });
        }
      }
    };

    $scope.submit_mass_edit_price = function() {
      if ($scope.mass_edit_price > 0) {
        $.fancybox.close();
        OfferService.submit_ospp_price(window.offer_id, $scope.ospp_items, window.user_id, $scope.filter.buyer_country_id, $scope.mass_edit_price, $scope.mass_edit_incoterm).then(function() {
          $scope.get_matched_stocklist();
        });
      }
    };

    $scope.submit_mass_edit_price_with_charge = function() {
      $scope.submitting_price_charge = true;
      OfferService.submit_ospp_price_charge(window.offer_id, $scope.ospp_items, window.user_id, $scope.filter.buyer_country_id, $scope.mass_edit_price_charge, $scope.mass_edit_incoterm).then(function() {
        $scope.submitting_price_charge = false;
        $scope.get_matched_stocklist();
        $.fancybox.close();
      });
    };

    $scope.$watch('selected_items', function() {
      $timeout(function() {
        if ($scope.selected_items && $scope.selected_items.length > 0)
          $('form#createXLS').submit();
      }, 300);
    });

    $scope.get_matched_method = function(item) {
      if (item.is_matched) {
        var method = '';

        if (item.matched_by === 0)
          method = 'Brand';
        else if (item.matched_by == 1)
          method = 'Product';
        else if (item.matched_by == 2)
          method = 'Group';

        if (item.matched_method === 0)
          method = method + ' Standard';
        else if (item.matched_method == 1)
          method = method + ' Relative';
        else if (item.matched_method == 2)
          method = method + ' Special (RW)';
        else if (item.matched_method == 3)
          method = method + ' Advanced (RW)';

        return method;
      } else {
        return '';
      }
    };

    $scope.$watch('filter.buyer_country_id', function() {
      $scope.supplier_freight_rates = [];
      if ($scope.filter.buyer_country_id && $scope.filter.buyer_country_id > 0) {
        OfferService.get_freight_rates_for_buyer(window.offer_id, $scope.filter.buyer_country_id).then(function(data) {
          $scope.supplier_freight_rates = data.freight_rates;
        });
      }
    });

    $scope.get_buyer_delivery_terms = function() {
      OfferService.get_delivery_terms_for_buyer(window.user_id).then(function(data) {
        $scope.buyer_delivery_terms = data.user_delivery_terms;
      });
    };

    $scope.get_country_extra_charge = function() {
      OfferService.get_country_extra_charge(window.offer_id, window.supplier_id, $scope.filter.buyer_country_id).then(function(data) {
        $scope.country_extra_charge = data.country_extra_charge;
      });
    };
    
    $scope.operators = [
      {
        value: 1,
        title: '+'
      },
      {
        value: 2,
        title: '+/-'
      }
    ];
    
    $scope.cuts = [
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      },
      {
        value: 3,
        title: '3'
      },
    ];
    
    $scope.wastes = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '1'
      },
      {
        value: 2,
        title: '2'
      }
    ];
    
    $scope.ranges = [
      {
        value: 0,
        title: '0'
      },
      {
        value: 1,
        title: '+-0.5'
      },
      {
        value: 2,
        title: '+-1'
      }
    ];

    $scope.mass_edit_incoterms = [
      {
        id: 3,
        name: 'FCA'
      },
      {
        id: 1,
        name: 'CFR'
      },
      {
        id: 2,
        name: 'DAP'
      },
    ];

    $scope.edit_item = function(item) {
      $scope.$broadcast('open_item_price_dialog', {
        item: item
      });
    };

    $scope.add_user_to_offer_campaign = function() {
      var users = [{
        id: window.user_id,
        company_title: window.user_company_title,
        business_relation: window.user_business_relation,
        country_id: window.user_country_id,
        country_name: window.user_country_name
      }];
      $scope.adding_user_to_campaign = true;
      OfferService.add_users_to_offer_campaign(window.offer_id, users, $scope.filter).success(function(data) {
        if (data.success)
          $scope.adding_user_to_campaign = false;
      });
    };

    $scope.review_selection = function() {
      var items = _.filter($scope.items, function(item) {
        return item.selection_quantity > 0;
      });
      if (items.length > 0) {
        $scope.has_selection_reels = _.findWhere(items, {
          is_reels: true
        });
        $scope.has_selection_sheets = _.findWhere(items, {
          is_reels: false
        });
        $scope.selection_items = items;
        $scope.existing_offer_requests = [];
        $scope.existing_offer_request = null;
        var filter = {
          page: 1,
          supplier_id: window.supplier_id,
          buyer_id: window.user_id,
          status: 1,
          order_status: 2,
          per_page: 100
        };
        OfferRequestService.get(filter).success(function(data) {
          _.each(data.offer_requests, function(offer_request) {
            $scope.existing_offer_requests.push({
              id: offer_request.id,
              title: '#' + offer_request.id + ' ' + offer_request.title
            });
            if (data.offer_requests.length > 0)
              $scope.existing_offer_request = data.offer_requests[0].id;
          });
        });
        $.fancybox($('div#review_selection'), {
          padding: '5',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          topRatio: 0.15,
          scrolling: 'no'
        });
      }
    };

    $scope.check_selection_items = function(is_reels) {
      _.each($scope.selection_items, function(item) {
        if (is_reels && item.is_reels)
          item.selection_checked = $scope.selections_reels_checked;
        else if (!is_reels && !item.is_reels)
          item.selection_checked = $scope.selection_sheets_checked;
      });
    };

    $scope.cancel_all_selection_items = function() {
      _.each($scope.selection_items, function(item) {
        item.selection_quantity = 0;
      });
      $scope.selection_items = [];
      $scope.selection_mode = false;
      $.fancybox.close();
    };

    $scope.cancel_selected_selection_items = function() {
      _.each($scope.selection_items, function(item) {
        if (item.selection_checked)
          item.selection_quantity = 0;
      });
      $scope.selection_items = _.reject($scope.selection_items, function(item) {
        return item.selection_checked;
      });
      if ($scope.selection_items.length === 0) {
        $.fancybox.close();
      }
    };

    $scope.create_offer_request = function() {
      $scope.creating_offer_request = true;
      OfferRequestService.create_from_offer_items(window.offer_id, window.user_id, $scope.selection_items).success(function(data) {
        if (data.success) {
          $scope.creating_offer_request = false;
          $scope.cancel_all_selection_items();
          window.location = '/admin/marketplace/offer_requests/items/' + data.offer_request_id;
        }
      });
    };

    $scope.add_to_offer_request = function() {
      $scope.adding_to_offer_request = true;
      OfferRequestService.add_offer_items($scope.existing_offer_request, $scope.selection_items).success(function(data) {
        if (data.success) {
          $scope.adding_to_offer_request = false;
          $scope.cancel_all_selection_items();
          window.location = '/admin/marketplace/offer_requests/items/' + data.offer_request_id;
        }
      });
    };

    $scope.init = function() {
      $scope._ = _;
      $scope.offer_id = window.offer_id;
      $scope.user_id = window.user_id;
      $scope.supplier_id = window.supplier_id;
      if (window.filter)
        window.filter.buyer_country_id = window.delivery_countries.length > 0 ? window.delivery_countries[0].id : null;
      $scope.filter = window.filter ? window.filter : $scope.get_filter();
      $scope.delivery_countries = window.delivery_countries;
      $scope.set_user_company_autocomplete($('input.user_company'));
      $scope.show_prices = true;
      $scope.show_fca = true;
      $scope.show_cfr = true;
      $scope.show_dap = true;
      $scope.mode = 'matching';
      $scope.user_company_title = window.user_company_title;
      $scope.user_country_id = window.user_country_id;
      $scope.supplier_freight_rates = [];
      $scope.buyer_delivery_terms = [];
      $scope.country_extra_charge = {};
      if (window.user_id > 0) {
        $scope.get_buyer_delivery_terms();
        $scope.get_matched_stocklist();
        $scope.get_country_extra_charge();
      }
      $scope.mass_edit_price = 0;
      $scope.mass_edit_incoterm = 3;
      $scope.show_ospp_prices = false;
      $scope.show_ospp_country_prices = false;
      $scope.show_order_prices = false;
      $scope.order_charge = 0;
    };

    $scope.init();
  }
}

OfferMatchingAnalysis.$inject = ['$scope', '$timeout', 'OfferService', 'UserService', 'OfferRequestService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-matching-analysis.ctrl.js